import faqApi from "../../../api/faq/faq";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  // 获取列表
  getList({ state }, { callback }) {
    console.log(state);
    faqApi.getListApi({ callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/faq/faq.js